import { useLang } from "../i18n/LanguageContext";
import { GiBookCover, GiLockedChest, GiMoonOrbit, GiStarsStack } from "react-icons/gi";

const COPY = {
  pl: {
    eyebrow: "Pokoik Morfeusza",
    title: "Konto ma być Twoją prywatną przestrzenią snów",
    subtitle:
      "Poza publicznym demo powstaje właściwa aplikacja: Pokoik, Księga Snów, Sejf, historia odczytów i powroty symboli w jednym miejscu.",
    benefits: [
      "Księga Snów z zapisanymi odczytami i notatkami",
      "Sejf dla najbardziej osobistych treści",
      "Historia snów, symboli i nastrojów",
      "Miejsce pod przyszłe głębsze interpretacje GPT",
    ],
    cta: "Pokoik w przygotowaniu",
    ctaHint: "Na tym etapie bez płatności — budujemy fundament aplikacji.",
  },
  en: {
    eyebrow: "Morpheus Room",
    title: "The account is meant to become your private dream space",
    subtitle:
      "Beyond the public demo, the real application is being shaped: Room, Dream Codex, Vault, reading history and recurring symbols in one place.",
    benefits: [
      "Dream Codex with saved readings and notes",
      "Vault for the most personal entries",
      "History of dreams, symbols and moods",
      "A place for future deeper GPT interpretations",
    ],
    cta: "Room in preparation",
    ctaHint: "No payments at this stage — we are building the application foundation.",
  },
};

export const Pricing = () => {
  const { lang } = useLang();
  const copy = COPY[lang] ?? COPY.pl;

  return (
    <section
      id="pricing"
      className="bg-ink-deep py-24 md:py-32 relative overflow-hidden"
      data-ui="home-pricing"
      data-testid="pricing-section"
    >
      <div
        className="absolute inset-0 opacity-[0.07] pointer-events-none home-pricing-aura"
        data-ui="home-pricing-aura"
      />
      <div
        className="max-w-4xl mx-auto px-6 md:px-10 relative"
        data-ui="home-pricing-inner"
      >
        <div
          className="border border-gold-muted/40 p-1 home-pricing-frame"
          data-ui="home-pricing-frame"
        >
          <div
            className="border border-gold-muted/30 p-10 md:p-16 text-center"
            data-ui="home-pricing-card"
          >
            <div
              className="flex justify-center text-gold-muted"
              data-ui="home-pricing-icon"
            >
              <GiMoonOrbit className="text-4xl" />
            </div>
            <span
              className="font-accent text-[11px] uppercase tracking-[0.35em] text-gold-muted mt-6 block"
              data-ui="home-pricing-eyebrow"
            >
              {copy.eyebrow}
            </span>
            <h2
              className="font-heading italic text-4xl md:text-5xl text-parchment mt-4 leading-tight"
              data-ui="home-pricing-title"
            >
              {copy.title}
            </h2>
            <p
              className="font-body text-base md:text-lg text-parchment/70 mt-6 max-w-2xl mx-auto leading-relaxed"
              data-ui="home-pricing-subtitle"
            >
              {copy.subtitle}
            </p>

            <ul
              className="mt-10 grid sm:grid-cols-2 gap-x-10 gap-y-4 text-left max-w-2xl mx-auto"
              data-ui="home-pricing-benefits"
            >
              {copy.benefits.map((b, i) => (
                <li
                  key={i}
                  className="flex items-start gap-3 font-body text-parchment/85"
                  data-ui="home-pricing-benefit"
                  data-testid={`pricing-benefit-${i}`}
                >
                  <span className="text-gold-muted font-heading text-xl leading-none mt-1">
                    {i === 1 ? <GiLockedChest className="text-base" /> : <GiStarsStack className="text-base" />}
                  </span>
                  <span>{b}</span>
                </li>
              ))}
            </ul>

            <div className="mt-12" data-ui="home-pricing-actions">
              <button
                data-ui="home-pricing-cta"
                data-testid="pricing-cta"
                className="inline-flex items-center gap-3 bg-gold text-ink-deep px-9 py-4 font-accent text-[12px] uppercase tracking-[0.25em] hover:bg-gold-light transition-colors"
              >
                <GiBookCover className="text-base" />
                {copy.cta}
              </button>
              <div
                className="font-body italic text-sm text-parchment/50 mt-4"
                data-ui="home-pricing-hint"
              >
                {copy.ctaHint}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
